import { useSelectRealUser } from "@shared/utils/hooks/misc";
import { useContext } from "react";
import { OnboardingContext } from "@shared/features/onboarding/Onboarding.context";
import { OnboardingDetailedStep } from "@shared/features/onboarding/types";
import useSharedWorkspace from "@shared/features/workspaces/useSharedWorkspace";
import { WorkspaceType } from "@shared/types";
import { useTradingIntent } from "features/onboarding/guided/intent";
import { markOnboardingLiveChoice } from "features/onboarding/common/utils";
import { useOnboardingAnalytics } from "analytics/onboarding";

const useStartLive = (): (() => void) => {
  const track = useOnboardingAnalytics();
  const { changeStep } = useContext(OnboardingContext)!;
  const { setWorkspaceType } = useSharedWorkspace({});
  const { intent } = useTradingIntent();
  const hasLiveAccount = !!useSelectRealUser()?.has_valid_clients_connected;
  return () => {
    if (!hasLiveAccount) markOnboardingLiveChoice();
    track("Trading Mode Selected", {
      trading_method: intent || "dca",
      trading_mode: "live",
      onboarding_path: hasLiveAccount ? "live_existing" : "live_connect",
    });
    changeStep(
      hasLiveAccount
        ? OnboardingDetailedStep.TRADING_METHOD
        : OnboardingDetailedStep.SELECT_EXCHANGE,
      {
        method: intent || "dca",
        startMode: "1",
        guided: "0",
        connectLive: hasLiveAccount ? "" : "1",
        exchange: "",
        "account-id": "",
        setup: "",
        preset: "",
        botUUID: "",
        prepareDemo: "",
        changePractice: "",
        customDemo: "",
      }
    );
    setWorkspaceType(WorkspaceType.USER);
  };
};

export default useStartLive;
